import { Spinner } from '@schibsted-svp/react-ui';

import { Container } from '../Container/Container';

import type { FC } from 'react';

import styles from './LoginMessage.module.scss';

const LoginMessage: FC = () => {
  return (
    <Container className={styles.container}>
      <p className={styles.content}>Logging in...</p>
      <Spinner />
    </Container>
  );
};

export { LoginMessage };
